<template>
    <b-btn v-if="isAvailable" :to="{ name: 'PurchasesShow', params: { id: purchase.id } }" class="btn-card-action btn-card-action-light my-1">Сделать не срочной</b-btn>
</template>

<script>
export default {
    name: 'cabinet-fl44-notice-card-change-length-button',
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    computed: {
        isAvailable() {
            return this.purchase.actions.change_length;
        }
    }
};
</script>
